export default __webpack_public_path__ + "static/media/19.65f95299.jpg";